// Flow types automatically removed

import PropTypes from 'prop-types'; //Components

import ErrorSuccessModal from './ErrorSuccessModal'; // Helpers

import { mutations } from '../utils/constants';
import {
    SuccessTitle,
    SuccessDescription,
    ErrorTitle,
    ErrorDescription,
} from '../messages/errorSuccessMessages';

const ErrorSuccessContainer = ({ mutationResponse, type, closeModal, modalOpen }) => {
    if (mutationResponse === mutations.responses.LOADING) {
        return null;
    }

    const isSuccess = mutationResponse === mutations.responses.SUCCESS;
    const title = isSuccess ? <SuccessTitle type={type} /> : <ErrorTitle type={type} />;
    const description = isSuccess ? (
        <SuccessDescription type={type} closeModal={closeModal} />
    ) : (
        <ErrorDescription type={type} />
    );
    return (
        <ErrorSuccessModal
            description={description}
            onClose={closeModal}
            isOpen={modalOpen}
            title={title}
            type={mutationResponse}
        />
    );
};

ErrorSuccessContainer.propTypes = {
    mutationResponse: PropTypes.string,
    type: PropTypes.string,
    modalOpen: PropTypes.bool,
    closeModal: PropTypes.func,
};
export default ErrorSuccessContainer;
